import React from "react";
import { Button, Stack, Typography } from "@mui/material";
import { blueGrey } from "@mui/material/colors";

import { LottieIcon, PageContainer } from "src/shared/ui";
import { LottieIconNames } from "src/shared/config";
import { ProductsGrid } from "src/widgets/ProductsGrid";

export const ProductsPage: React.FC = () => {
  return (
    <PageContainer
      mainComponent={
        <>
          <Stack
            width={1}
            height={1}
            direction="column"
            justifyContent="center"
            alignItems="flex-start"
            spacing={2}
            zIndex={99}
            sx={{
              alignItems: {
                xs: "center",
                sm: "flex-start",
              },
            }}
          >
            <Typography
              variant="h1"
              fontWeight="bold"
              color={blueGrey[700]}
              textTransform="uppercase"
              textAlign="center"
            >
              Products
            </Typography>

            <Button variant="contained" size="large">
              Contact us
            </Button>
          </Stack>

          <Stack
            sx={{
              display: {
                xs: "none",
                sm: "flex",
              },
            }}
          >
            <LottieIcon
              icon={LottieIconNames.PRODUCTS}
              autoPlay
              style={{
                position: "absolute",
                height: "calc(100% - 180px)",
                top: 0,
                right: 0,
              }}
            />
          </Stack>
        </>
      }
    >
      <ProductsGrid />
    </PageContainer>
  );
};
